import dayjs, { Dayjs } from 'dayjs';
import {
  ArrayParam,
  BooleanParam,
  JsonParam,
  NumberParam,
  QueryParamConfig,
  StringParam,
  withDefault,
} from 'use-query-params';

import { ResultsMode } from 'interfaces/experimentResults';

export const DEFAULT_PAGE_SIZE = 24;

export const resultsModeQueryParam: QueryParamConfig<ResultsMode> = withDefault(
  StringParam,
  ResultsMode.Published
) as QueryParamConfig<ResultsMode>;

export const filtersQueryParamsSchema = {
  labId: StringParam,
  cohortId: StringParam,
  cohortName: StringParam,
  page: withDefault(NumberParam, 1),
  pageSize: withDefault(NumberParam, DEFAULT_PAGE_SIZE),
  sortBy: JsonParam, // should not be here, we can make a different schema for this
  filters: JsonParam,
  features: withDefault(JsonParam, null),
  clinicalData: withDefault(JsonParam, null),
  compositeFilters: JsonParam,
  experimentResultsSelection: StringParam, // should not be here, we can make a different schema for this
  resultsMode: resultsModeQueryParam,
  featuresSelection: JsonParam, // should not be here, we can make a different schema for this
  queryId: withDefault(StringParam, null), // used for saving and loading queries
  slidesMode: withDefault(BooleanParam, false),
  searchTerm: withDefault(StringParam, null), // used for searching slides or cases
  caseIdsToInclude: withDefault(ArrayParam, []),
  slideIdsToInclude: withDefault(ArrayParam, []),
  uploadFilters: ArrayParam,
  skipPagination: BooleanParam, // used to skip pagination in some cases, e.g. when we want to get all slides for a study
  jobsFilters: JsonParam, // Jobs tab only. Filters the jobs list. Never sent to procedures as-is.
  jobsFiltersIncludeExclude: StringParam, // Jobs tab only.
  datasetJobFilters: JsonParam, // Dataset tab only. Filters cases/slides by related jobs.
  datasetJobFiltersIncludeExclude: StringParam, // Dataset tab include/exclude for datasetJobFilters.
};

export const exportFeaturesSchema = {
  studyId: StringParam,
  highlightedFeaturesOnly: BooleanParam,
  resultsMode: resultsModeQueryParam,
  orchestrationId: StringParam,
  hideExcluded: BooleanParam,
};

const DayJSDateParam = {
  encode: (date: Dayjs) => {
    if (!date?.isValid()) {
      return undefined;
    }
    return date.format('YYYY-MM-DD');
  },
  decode: (dateString: string) => {
    const date = new Date(dateString);
    return date ? dayjs(date) : undefined;
  },
};

export const accessionQueryParamsSchema = {
  page: NumberParam,
  dateOfScanFrom: DayJSDateParam,
  dateOfScanTo: DayJSDateParam,
  accessionId: withDefault(StringParam, ''),
  medicalRecordNumber: withDefault(StringParam, ''),
  labId: StringParam,
};
